/* TEK TÜKETİCİ KURALI — bir SignalR gövdesine ya yönlendirici ya App.jsx dokunur, ikisi birden asla.

   İki hub kanalı ikişer farklı gövde taşıyor:

     ReceiveFleetDispatchNotification
       • {type,title,body,...}      → Task 5'in yeni gövdesi (DispatchService, FleetPanelService)
       • {eventType,message,...}    → eski AdminDispatchNotificationConsumer DTO'su

     ReceiveDeliveryUpdateNotification
       • {Type:'DelayReminder',...} → FleetDelayReminderJobService
       • {Action:'StatusChanged'..} → sıradan teslimat durum değişimleri

   `type` taşıyan gövdeler yönlendiricinindir: başlık/gövde/ses/toast/masaüstü bildirimi
   ve derin bağlantı oradan çıkar. Taşımayanlar App.jsx'in işleyicilerinde kalır: veri
   tazeleme ve kayan teslimat kartı orada. Kural iki tarafta ayrı ayrı yazılırsa kaçınılmaz
   olarak ayrışır (bir olay iki kart / hiç kart) — bu yüzden tek fonksiyondan okunur. */

export function routerOwnedType(detail) {
    if (!detail || typeof detail !== 'object') return null;
    const raw = detail.type ?? detail.Type;
    if (typeof raw !== 'string') return null;
    return raw.trim() === '' ? null : raw;
}
